import React from 'react';

const AccountActivationTerms = ({ acceptTerms }) => (
  <>
    <div className="form-group">
      <label>
        Benvenuto! Attivando il tuo account accetti i nostri{' '}
        <a
          href="https://cdn-generali.ideal-rent.com/ideal/Termini-e-Condizioni-Generali-per-utilizzo-licenza.pdf"
          target="_blank"
        >
          Termini e Condizioni
        </a>
        .
      </label>
    </div>
    <div className="form-group">
      <input type="checkbox" id="acceptTerms" onChange={acceptTerms} required />
      <label htmlFor="acceptTerms">
        Accetto le previsioni di cui agli art. 9 (clausola risolutiva espressa)
        e art. 10 (foro competente) contenute nei{' '}
        <a
          href="https://cdn-generali.ideal-rent.com/ideal/Termini-e-Condizioni-Generali-per-utilizzo-licenza.pdf"
          target="_blank"
        >
          Termini e Condizioni
        </a>
        .
      </label>
    </div>
    <div className="form-group">
      <label>
        I tuoi dati sono trattati nei modi previsti nella{' '}
        <a
          href="https://cdn-generali.ideal-rent.com/ideal/Privacy-Policy-per-Utente-Finale.pdf"
          target="_blank"
        >
          Privacy Policy
        </a>
        .
      </label>
    </div>
  </>
);

export default AccountActivationTerms;
